export const indent = (str: string) => str.replaceAll(/(?<=^|\n)/g, '  ')
